// Unpublished Work © 2026 Deere & Company.
import React, {useEffect, useState} from 'react';
import {getIsEmployee} from '../services/user-type-service';
import {DOWNLOAD_ERROR_DETAILED, DOWNLOAD_ERROR_GENERIC} from '../constants/error-messages';

export const DownloadErrorPage = () => {
    const [isEmployee, setIsEmployee] = useState<boolean | undefined>();

    useEffect(() => {
        const fetchUserType = async () => {
            const employee = await getIsEmployee();
            setIsEmployee(employee);
        };

        fetchUserType();
    }, []);

    if (isEmployee === undefined) {
        return null;
    }

    return <div data-testid='download-error-page'>{isEmployee ? DOWNLOAD_ERROR_DETAILED : DOWNLOAD_ERROR_GENERIC}</div>;
};
